
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface PostMetadataSeoDescriptionProps {
  seoDescription: string;
  setSeoDescription: (seoDescription: string) => void;
}

const PostMetadataSeoDescription: React.FC<PostMetadataSeoDescriptionProps> = ({
  seoDescription,
  setSeoDescription,
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="seoDescription">SEO Meta Description</Label>
      <Textarea
        id="seoDescription"
        value={seoDescription}
        onChange={(e) => setSeoDescription(e.target.value)}
        placeholder="Description for search engines (max 160 characters)"
        rows={2}
        maxLength={160}
      />
      <p className="text-xs text-muted-foreground">
        {seoDescription.length}/160 characters
      </p>
    </div>
  );
};

export default PostMetadataSeoDescription;
